/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Presence_TInputs */

const en_tut_presence_t = /** @type {(inputs: Tut_Presence_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presence: status, working hours, and holidays`)
};

const id_tut_presence_t = /** @type {(inputs: Tut_Presence_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presence: status, jam kerja, dan hari libur`)
};

/**
* | output |
* | --- |
* | "Presence: status, working hours, and holidays" |
*
* @param {Tut_Presence_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_presence_t = /** @type {((inputs?: Tut_Presence_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Presence_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_presence_t(inputs)
	return en_tut_presence_t(inputs)
});